import React from 'react'
import "./deleteBinModal.css"

export const DeleteBinModal = ({binName , binDescription , onClose , deletebin }) => {

    const handleDelete = ()=>{
        deletebin()
        onClose()
    }
    return (
        <section className='delete-bin-cont'>
            <h3>Are you sure you want to <br /> delete this bin?</h3>
            <div className="delete-bin-pCont">
                <p>bin: <span>{binName}</span></p>
                <p>Description: <span>{binDescription}</span></p>
            </div>
            <div className='delete-bin-btnCont'>
                <button onClick={handleDelete}>Ok</button>
                <button onClick={onClose}>Cancel</button>
            </div>
        </section>
    )
}
